import { useEffect, useState } from "react";
import { EditTwoTone } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Spin,
  message,
  notification,
} from "antd";
import {
  callFetchPodcastByID,
  callUpdatePodcast,
} from "../../../../config/api";

const ModalPodcast = ({
  id,
  handleFetchPodcast,
}: {
  id: string;
  handleFetchPodcast: any;
}): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();

  const showModal = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const fetchPodcastById = async () => {
    const result: any = await callFetchPodcastByID(id);
    form.setFieldsValue(result.data);
  };
  useEffect(() => {
    fetchPodcastById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, open]);

  const onFinish = async (values: any) => {
    setLoading(true)
    const res: any = await callUpdatePodcast(id, values);
    if (res && res.statusCode === 200) {
      handleFetchPodcast();
      message.success("update success!");
      setOpen(false);
    } else {
      notification.error({
        message: "Đã có lỗi xảy ra",
        description: res.message,
      });
    }
    setLoading(false)
  };

  return (
    <Spin spinning={loading}>
      <Button
        style={{ border: "1px solid #f57800" }}
        type="primary"
        ghost
        onClick={showModal}>
        <EditTwoTone twoToneColor="#f57800" style={{ cursor: "pointer" }} />
      </Button>
      <Modal
        title="Chỉnh sửa podcast"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Lưu"
        cancelText="Hủy"
        maskClosable={false}
        width={840}
        onCancel={onClose}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter name" }]}>
                <Input placeholder="Please enter title" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="urlPodcast"
                label="URL Podcast"
                rules={[{ required: true, message: "Please enter image" }]}>
                <Input placeholder="Please enter image" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="image"
                label="Image"
                rules={[{ required: true, message: "Please enter image" }]}>
                <Input placeholder="Please enter image" />
              </Form.Item>
            </Col>
          </Row>

         
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalPodcast;
